<template>
  <v-button outlined block :flat="false" :to="addEventUrl">
    <v-icon icon="today" class="mr-1"></v-icon>
    Add to Calendar
  </v-button>
</template>

<script>
import { mapGetters } from "vuex"

import { generateURL } from "@/lib/add-event-helpers"

export default {
  props: {
    startsAt: { type: [String, Date], required: true },
    endsAt: { type: [String, Date], required: true },
    title: { type: String, required: true },
    url: { type: String, required: true }
  },

  computed: {
    ...mapGetters(["account", "app"]),

    addEventUrl() {
      return generateURL({
        startsAt: this.startsAt,
        endsAt: this.endsAt,
        title: `${this.app.name} - ${this.title}`,
        description: this.eventDescription,
        timezone: this.account.timezone
      })
    },

    eventDescription() {
      return `Join us on the ${this.app.name} app for ${this.title}<br /><br />Click here to join: ${this.url}`
    }
  }
}
</script>
